import mapPictures from "../../../../shared/image-mapper";
import OnboardingType from "../../../../shared/onboarding/onboarding-type";
import { sortByName } from "../../../../shared/utility";
import {
  SEARCH_SCENES_FOR_COSTUMES
} from "../../../scenes/search/ducks/actions";
import { DELETE_MULTIPLE_COSTUMES, SAVE_ALIAS_COSTUME, SAVE_UNALIAS_COSTUME } from "../overview/ducks/actions";
import { ASSIGN_SCENES_TO_COSTUME, CHANGE_COSTUME_TO_PROP, COSTUME_SET_RETURN_URL, FETCH_COSTUME_URL_PREVIEW } from "./actions";

interface ActionState {
  costumes: any[];
  loading: boolean;
  loadingSceneSettings: boolean;
  costume: any;
  imageFiles: any[];
  readOnly: boolean;
  scenes: any[];
  loadingScenes: boolean;
  onboardingSteps: OnboardingType[];
  findingInScript: boolean;
  searchingScenes: boolean;
  returnUrl: string | null;
  loadingUrlPreview?: boolean;
}

export const OnboardingStep1ClassName = 'costume-scenes-onboarding-step-1';
export const OnboardingStep2ClassName = 'costume-scenes-onboarding-step-2';
export const OnboardingStep3ClassName = 'costume-scenes-onboarding-step-3';
export const OnboardingStep4ClassName = 'costume-scenes-onboarding-step-4';
export const OnboardingStep5ClassName = 'costume-scenes-onboarding-step-5';

const defaultState: ActionState = {
  costumes: [],
  loading: true,
  loadingSceneSettings: false,
  costume: {},
  imageFiles: [],
  readOnly: false,
  scenes: [],
  loadingScenes: true,
  findingInScript: false,
  searchingScenes: false,
  returnUrl: null,
  loadingUrlPreview: false,
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Scene Search',
      content: `        
        Use this to quickly select the scenes that match the selected criteria.
      `
    },
    {
      target: '.' + OnboardingStep2ClassName,
      title: 'Script Search',
      content: `Or use this to search the script for the name of the costume, and select any scenes that match. You can chose which parts of the script to select.`
    },
    {
      target: '.' + OnboardingStep3ClassName,
      title: 'Select',
      content: `Or just select or unselect all scenes.`
    },
    {
      target: '.' + OnboardingStep4ClassName,
      title: 'Manual',
      content: `<p>If any scenes have not been selected using any of the above methods, then you can manually select or unselect a scene.</p>
                <p>This list only includes scenes which the selected character or background characters are in.</p>`
    },
    {
      target: '.' + OnboardingStep5ClassName,
      title: 'Save',
      content: `Once you have the desired scenes selected, don't forget to click Save.`
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case "FETCH_COSTUMES_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case "CLEAR_COSTUME": {
      return {
        ...state,
        loading: false,
        costume: null,
        errors: null
      };
    }

    case "COSTUME_SET_NAME": {
      const costume = { name: action.meta.name, nameInScript: action.meta.name, acquisitionMethod: 1 }
      return {
        ...state,
        costume: costume
      };
    }

    case "FETCH_NEXT_COSTUME_NUMBER": {
      let nextNumber = 1;
      if (state.costumes && state.costumes.length > 0) {
        const maxNumber = Math.max.apply(
          null,
          state.costumes.map((costume) => {
            return costume.number;
          })
        );
        nextNumber = maxNumber + 1;
      }
      return {
        ...state,
        costume: { number: nextNumber }
      };
    }


    case "FETCH_COSTUMES_FULFILLED": {
      return {
        ...state,
        costumes: action.payload.data.costumes,
        readOnly: action.payload.data.readOnly,
        loading: false,
        errors: null
      };
    }

    case "FETCH_SINGLE_COSTUME_PENDING": {
      return {
        ...state,
        costume: null,
        loadingCostume: true
      };
    }

    case "FETCH_SINGLE_COSTUME_FULFILLED": {
      let costume = action.payload.data;
      mapPictures(costume);

      return {
        ...state,
        costume,
        loadingCostume: false,
        errors: null
      };
    }

    case "FETCH_SINGLE_COSTUME_REJECTED": {
      return {
        ...state,
        costume: null,
        loadingCostume: false,
        errors: action.payload.response.data.errors,
      };
    }

    case "UPDATE_SINGLE_COSTUME_PENDING": {
      return {
        ...state,
        costume: action.payload,
        loadingCostume: true,
        errors: null
      };
    }

    case "UPLOAD_IMAGES_PENDING": {
      return {
        ...state,
        loadingCostume: true
      };
    }

    case "UPLOAD_IMAGES_REJECTED": {
      return {
        ...state,
        loadingCostume: false,
        errors: action.payload.response.data.errors,
      };
    }

    case CHANGE_COSTUME_TO_PROP + "_PENDING": {
      return {
        ...state,
        loadingSetDressing: true,
        errors: null
      };
    }

    case CHANGE_COSTUME_TO_PROP + "_FULFILLED": {
      const costumes = Array.from(state.costumes);
      var index = costumes.findIndex(s => s.id === action.meta.costume.id);
      if (index >= 0) {
        costumes.splice(index);
      }

      return {
        ...state,
        costumes: costumes,
        loadingCostume: false,
        errors: null,
        redirect: { to: "prop", id: action.payload.data.propId }
      };
    }

    case CHANGE_COSTUME_TO_PROP + "_REJECTED": {
      return {
        ...state,
        setDressing: action.meta.costume,
        errors: action.payload.response.data.errors,
        loadingCostume: false
      };
    }

    case "UPLOAD_IMAGES_FULFILLED": {
      return {
        ...state,
        loadingCostume: false
      };
    }

    case "UPDATE_SINGLE_COSTUME_FULFILLED": {
      const costume = {
        ...action.meta.costume,
        ...action.payload.data.costume
      };
      const costumes: any = state.costumes.map((c: any, index: number) => {
        if (c.id === costume.id) {
          return { ...c, ...costume };
        } else {
          return c;
        }
      });
      sortByName(costumes);
      return {
        ...state,
        costume,
        costumes,
        loadingCostume: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case "UPDATE_SINGLE_COSTUME_REJECTED": {
      return {
        ...state,
        costume: action.meta.costume,
        errors: action.payload.response.data.errors,
        loadingCostume: false
      };
    }

    case "ADD_SINGLE_COSTUME_PENDING": {
      return {
        ...state,
        errors: null,
        loadingCostume: true
      };
    }

    case "ADD_SINGLE_COSTUME_FULFILLED": {
      let costume: any = action.payload.data.costume;
      let costumes = [costume, ...state.costumes];
      sortByName(costumes);
      return {
        ...state,
        costume,
        costumes,
        loadingCostume: false,
        errors: null,
        redirect: { to: "scenes", id: costume.id }
      };
    }

    case "ADD_SINGLE_COSTUME_REJECTED": {
      return {
        ...state,
        costume: action.meta.costume,
        errors: action.payload.response.data.errors,
        loadingCostume: false
      };
    }

    case "DELETE_SINGLE_COSTUME_PENDING": {
      return {
        ...state,
        costume: action.payload,
        loadingCostume: true,
        errors: null
      };
    }

    case "DELETE_SINGLE_COSTUME_FULFILLED": {
      const costume = action.meta.costume;
      const costumes: any = state.costumes.filter((c: any, index: number) => {
        return c.id !== costume.id;
      });

      return {
        ...state,
        costume: null,
        costumes,
        loadingCostume: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case "DELETE_SINGLE_COSTUME_REJECTED": {
      return {
        ...state,
        costume: action.meta.costume,
        errors: action.payload.response.data.errors,
        loadingCostume: false
      };
    }

    case "ADD_COSTUME_IMAGE_FILES": {
      let mainImageUrl = state.costume.mainImageUrl;
      if (!mainImageUrl) {
        mainImageUrl = action.meta.imageFiles[0].name;
      }

      return {
        ...state,
        imageFiles: [...state.imageFiles, ...action.meta.imageFiles],
        costume: { ...state.costume, mainImageUrl: mainImageUrl }
      };
    }

    case "ADD_COSTUME_IMAGE_URL": {
      let costume: any = { ...state.costume };
      let mainImageUrl = state.costume.mainImageUrl;
      if (!mainImageUrl) {
        mainImageUrl = action.meta.url;
      }

      if (costume?.imageUrls) {
        costume = {
          ...costume,
          imageUrls: [...costume?.imageUrls, action.meta.url],
          mainImageUrl: mainImageUrl
        };
      } else {
        costume = {
          ...costume,
          imageUrls: [action.meta.url],
          mainImageUrl: mainImageUrl
        };
      }
      return {
        ...state,
        costume: costume
      };
    }

    case "DELETE_COSTUME_IMAGE_URL": {
      let imageUrls: any = state.costume.imageUrls;
      imageUrls = imageUrls.filter((item) => {
        return item !== action.meta.url;
      });
      return {
        ...state,
        costume: { ...state.costume, imageUrls: imageUrls }
      };
    }

    case "DELETE_COSTUME_IMAGE_FILE": {
      let imageFiles = state.imageFiles.filter((file) => {
        return file.name !== action.meta.fileName;
      });
      return {
        ...state,
        imageFiles: imageFiles
      };
    }

    case "COSTUME_MAIN_IMAGE_CHANGED": {
      return {
        ...state,
        costume: { ...state.costume, mainImageUrl: action.meta.url }
      };
    }

    case "CLEAR_REDIRECT": {
      return {
        ...state,
        costume: null,
        redirect: null
      };
    }

    case "FETCH_ALL_SCENES_FOR_COSTUMES_PENDING": {
      return {
        ...state,
        loadingScenes: true
      };
    }

    case "FETCH_ALL_SCENES_FOR_COSTUMES_FULFILLED": {
      const scenes = action.payload.data.scenes.map((scene) => {
        return { ...scene, name: `${scene.number}. ${scene.settingName}` };
      });
      return {
        ...state,
        scenes,
        loadingScenes: false,
        errors: null
      };
    }

    case "SET_SCENE_ASSIGNED_TO_COSTUME": {
      return {
        ...state,
        selectedSceneIds: [action.meta.sceneId]
      };
    }

    case "SET_LOADING_SCENE_SETTINGS":
    case "FETCH_SCENES_ASSIGNED_TO_COSTUMES_PENDING": {
      return {
        ...state,
        loadingSceneSettings: true
      };
    }

    case "FETCH_SCENES_ASSIGNED_TO_COSTUMES_FULFILLED": {
      return {
        ...state,
        selectedSceneIds: action.payload.data.sceneIds,
        loadingSceneSettings: false,
        errors: null
      };
    }

    case ASSIGN_SCENES_TO_COSTUME + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors
      }
    }

    case ASSIGN_SCENES_TO_COSTUME + "_FULFILLED": {
      return {
        ...state,
        loading: false,
        errors: null,
        redirect: { to: state.returnUrl || "list" }
      };
    }

    case "FETCH_ALL_CHARACTERS_FOR_COSTUMES_FULFILLED": {
      return {
        ...state,
        characters: action.payload.data.characters,
        loading: false,
        errors: null
      };
    }

    case "FETCH_ALL_CHARACTERS_FOR_COSTUMES_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.data.errors
      };
    }

    case "FETCH_ALL_BACKGROUND_CHARACTERS_FOR_COSTUMES_FULFILLED": {
      return {
        ...state,
        backgroundCharacters: action.payload.data.backgroundCharacters,
        loading: false,
        errors: null
      };
    }

    case "FETCH_ALL_BACKGROUND_CHARACTERS_FOR_COSTUMES_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.data.errors
      };
    }

    case "FETCH_ALL_SCENE_SETTINGS_FOR_COSTUMES_FULFILLED": {
      return {
        ...state,
        sceneSettings: action.payload.data.sceneSettings,
        loading: false,
        errors: null
      };
    }

    case SEARCH_SCENES_FOR_COSTUMES + "_PENDING": {
      return {
        ...state,
        searchingScenes: true
      };
    }

    case SEARCH_SCENES_FOR_COSTUMES + "_FULFILLED": {
      return {
        ...state,
        searchedScenes: action.payload.data.scenes,
        selectSearchedScenes: action.meta.selectSearchedScenes,
        loading: false,
        searchingScenes: false,
        errors: null
      };
    }

    case SEARCH_SCENES_FOR_COSTUMES + "_REJECTED": {
      return {
        ...state,
        searchingScenes: false,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case "FETCH_SCRIPT_DAYS_FOR_COSTUMES_FULFILLED": {
      return {
        ...state,
        scriptDays: action.payload.data.days,
        loading: false,
        errors: null
      };
    }

    case FETCH_COSTUME_URL_PREVIEW + "_PENDING": {
      return {
        ...state,
        loadingUrlPreview: true
      };
    }

    case FETCH_COSTUME_URL_PREVIEW + "_FULFILLED": {
      let costume = { ...state.costume } as any;
      const url = action.meta.url;
      if (!costume) {
        costume = {} as any;
      }

      costume.link = url;

      if (!costume.name) {
        costume.name = action.payload.data.title;
      }

      if (!costume.description) {
        costume.description = action.payload.data.description;
      }

      if (action.payload.data.imageUrl && !costume.images?.some((i: any) => i.url == action.payload.data.imageUrl)) {
        const image = { url: action.payload.data.imageUrl, isMain: !costume.images || (costume.images && costume.images.length === 0) };
        costume.images = [...(costume.images || []), image];
        costume.mainImageIndex = costume.images?.findIndex((i: any) => i.isMain);

        costume.pictures = costume.images.map((img: any) => {
          return { url: img.url, isPrimary: img.isMain, isUploaded: true };
        });
      }

      return {
        ...state,
        costume,
        loadingUrlPreview: false
      };
    }

    case FETCH_COSTUME_URL_PREVIEW + "_REJECTED": {
      return {
        ...state,
        loadingUrlPreview: false
      };
    }

    case "PROP_SEARCH_SCRIPT_PENDING": {
      return {
        ...state,
        findingInScript: true
      }
    }

    case "PROP_SEARCH_SCRIPT_FULFILLED": {
      let searchedScenes = action.payload.data.scenes;
      const sceneIds = state.scenes.map(s => s.id);
      const filteredScenes = searchedScenes.filter(s => sceneIds.indexOf(s) > -1);
      return {
        ...state,
        searchedScenes: filteredScenes.map((id) => { return { id } }),
        selectSearchedScenes: action.meta.selectSearchedScenes,
        loading: false,
        errors: null,
        findingInScript: false
      };
    }

    case "PROP_SEARCH_SCRIPT_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false,
        findingInScript: false
      };
    }

    case "CLEAR_SEARCH_SCENES_FOR_COSTUMES": {
      return {
        ...state,
        searchedScenes: [],
        loading: false,
        errors: null
      };
    }

    case COSTUME_SET_RETURN_URL: {
      return {
        ...state,
        returnUrl: action.meta.returnUrl
      };
    }

    case SAVE_ALIAS_COSTUME + "_FULFILLED": {
      const aliasCostume = action.meta.aliasCostume;
      let costumes = [...state.costumes];
      const aliasCostumeIndex = costumes.findIndex(
        (c) => c.id === aliasCostume.id
      );

      costumes.splice(aliasCostumeIndex, 1);

      return {
        ...state,
        costumes
      };
    }

    case SAVE_UNALIAS_COSTUME + "_FULFILLED": {
      const aliasCostume = action.meta.aliasCostume;
      let costumes = [...state.costumes];
      costumes.push(aliasCostume);
      sortByName(costumes);

      return {
        ...state,
        costumes
      };
    }

    case DELETE_MULTIPLE_COSTUMES + "_FULFILLED": {
      const deletedCostumeIds = action.meta.costumeIds;
      let costumes = state.costumes.filter(
        (costume) => !deletedCostumeIds.includes(costume.id)
      );

      return {
        ...state,
        costumes
      };
    }

    default:
      return state;
  }
};

export default reducer;
